import { render, staticRenderFns } from "./FrameworkWidget.vue?vue&type=template&id=38d3c48c"
import script from "./FrameworkWidget.vue?vue&type=script&lang=js"
export * from "./FrameworkWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports